import { FunctionComponent, useCallback, useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { Modal as HeroModal } from '@conexasaude/conexa-hero'
import { useModalContext } from './contexts/ModalContext'
import { ModalProps } from './types'

const Modal: FunctionComponent<ModalProps> = ({
  children,
  id,
  onDismiss,
  withCloseButton,
  title,
  size,
  ...rest
}) => {
  const { open, settings, closeModal } = useModalContext()
  const location = useLocation()
  const previousPathnameRef = useRef(location.pathname)

  const handleModalDismiss = useCallback(() => {
    closeModal()
    onDismiss?.()
  }, [closeModal, onDismiss])

  useEffect(() => {
    if (
      previousPathnameRef?.current !== location?.pathname &&
      location.pathname !== '/chamada'
    ) {
      previousPathnameRef.current = location?.pathname
      if (!settings?.persistent) {
        closeModal()
      }
    }
  }, [closeModal, location, settings?.persistent])

  return (
    <HeroModal
      {...rest}
      title={settings?.title || title || ''}
      closeOnClickOutside={!settings?.persistent}
      size={settings?.width || size || 450}
      onClose={handleModalDismiss}
      opened={open === id}
      withCloseButton={withCloseButton || !settings?.persistent}
    >
      {children}
    </HeroModal>
  )
}

export default Modal
